import styled from 'styled-components';

export const TopBar = styled.div`
  width: 100%;
  height: 64px;
  min-height: 64px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 24px;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const TopBarRight = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

export const OrderInfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  white-space: nowrap;
`;

export const Reference = styled.div`
  color: ${({ theme }) => theme.colors.greys.darkest};
  font: ${({ theme }) => theme.fonts.h3Bold700};
`;

export const LastUpdate = styled.div`
  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textSmallHeight14};
`;

export const TopBarButtons = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;
